import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ProdByExtractionPointChartComponent } from '../../production-by-street/prod-by-extraction-point-chart/prod-by-extraction-point-chart.component';

@Component({
  selector: 'app-prod-vs-plan-modal-chart',
  templateUrl: './prod-vs-plan-modal-chart.component.html',
  styleUrls: ['./prod-vs-plan-modal-chart.component.scss'],
})
export class ProdVsPlanModalChartComponent extends ProdByExtractionPointChartComponent implements OnInit {
  @ViewChild('chartTarget', { read: ElementRef, static: false }) public chartTarget: ElementRef;
  @Input() public zoneName: string;
  @Input() public streetName: string;
  @Input() public extractionPointDetailList: any[];
  @Input() public loopByTypeTruck: any;
  @Input() public shiftLabel: string;

  public dataProductionList: any;

  protected chart: Highcharts.Chart;
  constructor(
    protected langService: LanguageService,
    protected parameterService: ParameterHandlerService,
    protected googleAnalyticsService: GoogleAnalyticsService,
  ) {
    super(langService, parameterService, googleAnalyticsService);
  }

  ngOnInit() {}

  /**
   * Function to build series for display chart values
   *
   * @param extractionPointDetailList data to fill chart view
   */
  protected buildSeriesForChart(extractionPointDetailList: any): any[] {
    return [
      {
        name: this.langService.message('non-schedule'),
        data: extractionPointDetailList.map((production) => production.doneLoops.nonSchedule),
        color: '#29BCDE80',
        borderColor: '#29BCDE',
        borderWidth: 2,
        states: {
          hover: {
            color: '#29BCDE',
          },
        },
        stack: 'doneLoops',
      },
      {
        name: this.langService.message('remnant-shelves'),
        data: extractionPointDetailList.map((production) => production.toDoneLoops.remainder),
        color: '#D3721880',
        borderColor: '#D37218',
        borderWidth: 2,
        states: {
          hover: {
            color: '#D37218',
          },
        },
        stack: 'toDoneLoops',
      },
      {
        name: this.langService.message('scheduled-shelves'),
        data: extractionPointDetailList.map((production) => production.toDoneLoops.scheduled),
        color: '#AFAFAF80',
        borderColor: '#AFAFAF',
        borderWidth: 2,
        states: {
          hover: {
            color: '#AFAFAF',
          },
        },
        stack: 'toDoneLoops',
      },
      {
        name: this.langService.message('total-shelves'),
        data: extractionPointDetailList.map((production) => production.doneLoops.done),
        color: '#22D98380',
        borderColor: '#22D983',
        borderWidth: 2,
        states: {
          hover: {
            color: '#22D983',
          },
        },
        stack: 'doneLoops',
      },
    ];
  }
}
